import React from 'react';

import SectionArrow from '../../assets/icon/section-arrow.svg';

import './NextSectionButton.scss';

const NextSectionButton = ({ title, sectionId }) => {
  const handleClick = () => {
    if (typeof sectionId !== 'undefined') {
      const nextSection = document.getElementById(sectionId);

      nextSection?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <button
      aria-label="Click to view next section"
      className="next-section-btn"
      onClick={handleClick}
    >
      <span>{title}</span>
      <img src={SectionArrow} alt="section arrow" />
    </button>
  );
};

export default NextSectionButton;
